import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./Testimonials.module.css";
import { TESTIMONIALS } from "../../../data/testimonials";
import { Animate } from "../../animations";

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <section className={styles.testimonials}>
      <div className={styles.testimonialsInner}>
        <Animate variant="fadeUp">
          <h4 className={styles.heading}>Testimonials</h4>
          <h1 className={styles.title} id="heading-large">
            Stories from Our Students
          </h1>
        </Animate>
        <Animate variant="scaleIn" delay={100}>
          <div className={styles.sliderContainer}>
            <Slider {...settings}>
              {TESTIMONIALS.map((t) => (
                <div key={t.id}>
                  <div className={styles.slide}>
                    <img src={t.image} alt={t.name} className={styles.avatar} />
                    <div className={styles.description}>
                      <p className={styles.comment}>{t.comment}</p>
                      <h2 className={styles.name} id="heading-md">
                        {t.name}
                      </h2>
                      <p className={styles.position}>{t.position}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </Animate>
      </div>
    </section>
  );
};

export default Testimonials;
